module.exports = {"workerPath":"/serviceWorker.7a6c88b6.js"};